import TransactionJournal from '@/transaction-journal/TransactionJournal.vue'
import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import {PanelContent} from '@tritt/multipanel'

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()
export const TRANSACTION_JOURNAL: PanelContent = {
    componentName: 'TransactionJournal',
    component: TransactionJournal,
    meta: {requiresOrg: true}
}

const icon = 'i-ph-book-fill'
const label = 'Bilagsjournal'
const hotkey = 'q'

registerNavigationCommand({
    route: TRANSACTION_JOURNAL,
    label,
    icon,
    hotkey
})

registerNavigationEntry(NavGroup.REPORTS, {
    title: label,
    key: 'transaction-journal',
    icon,
    target: TRANSACTION_JOURNAL,
    sortOrder: 0
})

registerRoute(TRANSACTION_JOURNAL)
registerHotkey(hotkey, TRANSACTION_JOURNAL)
buildSimpleCrumb(TRANSACTION_JOURNAL, label, icon, true)